<!--<template lang="html">-->
<template>
  <b-overlay
    :show="loading"
    rounded
    opacity="0.6"
    spinner
    spinner-variant="primary"
    class="order-book-container"
    @hidden="!loading"
  >
    <div class="order-book-wrapper" header-tag="header">
      <p v-if="$mq !== 'mobile'" class="header title-8">
        {{ $t('trade.order-book') }}
      </p>
      <div class="order-book-switcher">
        <div
          class="order-book-switcher-item"
          :class="{ active: orderBookType === 'both' }"
          @click.stop="
            () => {
              orderBookType = 'both'
              scrollToBottom()
            }
          "
        >
          <div class="order-book-switcher-item__red"></div>
          <div class="order-book-switcher-item__green"></div>
        </div>
        <div
          class="order-book-switcher-item"
          :class="{ active: orderBookType === 'buy' }"
          @click.stop="
            () => {
              orderBookType = 'buy'
              scrollToBottom()
            }
          "
        >
          <div class="order-book-switcher-item__green"></div>
          <div class="order-book-switcher-item__green"></div>
        </div>
        <div
          class="order-book-switcher-item"
          :class="{ active: orderBookType === 'sell' }"
          @click.stop="
            () => {
              orderBookType = 'sell'
              scrollToBottom()
            }
          "
        >
          <div class="order-book-switcher-item__red"></div>
          <div class="order-book-switcher-item__red"></div>
        </div>
      </div>
      <div
        v-if="(orders && orders.length) || (offers && offers.length)"
        class="combined-order-book"
        :class="{ [orderBookType]: true }"
      >
        <div
          ref="sellBook"
          id="sell-book"
          class="order-book sell"
          v-if="orderBookType !== 'buy'"
        >
          <div class="order-book-table-wrapper">
            <ol class="offer-ordered-list">
              <table class="trade sell">
                <thead>
                  <tr>
                    <!-- <th>№</th> -->
                    <th>
                      {{
                        $t('order.slotted-price', {
                          type: $t('order.sell-short'),
                        })
                      }}
                    </th>
                    <th class="text-right">{{ $t('order.quantity') }}</th>
                    <th class="text-right">{{ $t('order.total') }}</th>
                  </tr>
                </thead>
                <TransitionGroup tag="tbody" name="fade" class="container">
                  <tr
                    v-for="(offer, index) in offers"
                    :key='"offer_" + (offer?.md_entry_id || index)'
                  >
                    <td v-if="brand.stype === 1 || brand.bond_type === 200">
                      {{ offer.price | currency('', '₮') }}
                    </td>
                    <td v-else>
                      {{ (offer.price * 1000) | currency('', '₮') }}
                    </td>
                    <td>
                      {{ offer.size | currency('no-precision', '') }}
                    </td>
                    <td v-if="brand.stype === 1 || brand.bond_type === 200">
                      {{ (offer.price * offer.size) | currency }}
                    </td>
                    <td v-else>
                      {{
                        ((offer.price * 1000) * offer.size) | currency
                      }}
                    </td>
                  </tr>
                </TransitionGroup>
              </table>
            </ol>
          </div>
        </div>
        <div class="order-book" v-if="orderBookType !== 'sell'">
          <ol class="order-ordered-list">
            <table class="trade buy">
              <thead>
                <tr>
                  <!-- <th>№</th> -->
                  <th>
                    {{
                      $t('order.slotted-price', { type: $t('order.buy-short') })
                    }}
                  </th>
                  <th class="text-right">{{ $t('order.quantity') }}</th>
                  <th class="text-right">{{ $t('order.total') }}</th>
                </tr>
              </thead>
              <TransitionGroup tag="tbody" name="fade" class="container">
                <tr
                  v-for="(order, index) in orders"
                  :key='"order_" + (order?.md_entry_id || index)'
                >
                  <td v-if="brand.stype === 1 || brand.bond_type === 200">
                    {{ order.price | currency('', '₮') }}
                  </td>
                  <td v-else>
                    {{ (order.price * 1000) | currency('', '₮') }}
                  </td>
                  <td class="text-right">
                    {{ order.size }}
                  </td>
                  <td v-if="brand.stype === 1 || brand.bond_type === 200">
                    {{ (order.price * order.size) | currency }}
                  </td>
                  <td v-else>
                    {{
                      ((order.price * 1000) * order.size) | currency
                    }}
                  </td>
                </tr>
              </TransitionGroup>
            </table>
          </ol>
        </div>
      </div>
      <div class="py-5" v-else>
        <empty type="order" />
      </div>
    </div>
  </b-overlay>
</template>

<script>
import Empty from '../Empty'
import OrderBookMixin from '../../mixins/OrderBookMixin'

export default {
  components: { Empty },
  props: {
    brand: {
      type: Object,
      required: true,
    },
    orders: {
      type: Array,
      default: () => [],
    },
    offers: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [ OrderBookMixin ],
  data() {
    return {
      orderBookType: 'both',
      selectedOffer: null,
      selectedOrder: null,
    }
  },
  watch: {
    offers() {
      this.scrollToBottom()
    },
    orders() {
      this.scrollToBottom()
    }
  },
  methods: {
    handleOrder(order) {
      this.$emit('order', order)
      this.selectedOrder =
        parseFloat(this.selectedOrder) === parseFloat(order.price) ?
          null : order.price
    },
    handleOffer(offer) {
      this.$emit('order', offer)

      this.selectedOffer =
        parseFloat(this.selectedOffer) === parseFloat(offer.price) ?
          null : offer.price
    },
  },
}
</script>

<style src="./OrderBook.scss" lang="scss" />
